import * as React from 'react';
import './modal.css';

export const modalHabitat: React.StatelessComponent<{}> = ({ children }) => {
  return <div className="dialog-habitat">{children}</div>;
};
